import { cn } from '../lib/utils';
import type { StageStatus, InvoiceStatus, ProjectStatus } from '../types';
import {
  STAGE_STATUS_CONFIG,
  INVOICE_STATUS_CONFIG,
  PROJECT_STATUS_CONFIG,
} from '../lib/utils';

export function StageBadge({ status }: { status: StageStatus }) {
  const cfg = STAGE_STATUS_CONFIG[status];
  return (
    <span className={cn('inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium', cfg.bg, cfg.color)}>
      {cfg.label}
    </span>
  );
}

export function InvoiceBadge({ status }: { status: InvoiceStatus }) {
  const cfg = INVOICE_STATUS_CONFIG[status];
  return (
    <span className={cn('inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium', cfg.bg, cfg.color)}>
      <span className={cn('w-1.5 h-1.5 rounded-full', cfg.dot)} />
      {cfg.label}
    </span>
  );
}

export function ProjectBadge({ status }: { status: ProjectStatus }) {
  const cfg = PROJECT_STATUS_CONFIG[status];
  return (
    <span className={cn('inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium', cfg.bg, cfg.color)}>
      {cfg.label}
    </span>
  );
}

export function RoleBadge({ role }: { role: string }) {
  const map: Record<string, string> = {
    super_admin: 'bg-gray-900 text-white',
    admin: 'bg-rose-100 text-rose-700',
    sales: 'bg-blue-100 text-blue-700',
    pm: 'bg-teal-100 text-teal-700',
    sales_pm: 'bg-indigo-100 text-indigo-700',
    viewer: 'bg-gray-100 text-gray-500',
  };
  const label: Record<string, string> = {
    super_admin: 'Super Admin',
    admin: 'Admin',
    sales: 'Sales',
    pm: 'PM',
    sales_pm: 'Sales & PM',
    viewer: 'Viewer',
  };
  return (
    <span className={cn('inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium', map[role] ?? 'bg-gray-100 text-gray-600')}>
      {label[role] ?? role}
    </span>
  );
}
